<template>
  <div class="counter-marker">
    <div class="counter-marker__container">
      <div class="mark-group">
        <mark-item v-for="i in count" :key="i" :active="active === i - 1" @click="$emit('click', i - 1)"/>
      </div>
      <dynamic-arrow :transform="active" :count="count" />
    </div>
  </div>
</template>

<script>
  import MarkItem from './components/MarkItem.vue';
  import DynamicArrow from './components/DynamicArrow.vue';
  export default {
    props: {
      count: {
        type: Number,
        default: 1,
        required: false,
        validator: value => {
          return value > 0 && value % 1 === 0;
        }
      },
      active: {
        type: Number,
        default: 0,
        required: false,
        validator: value => {
          return value >= 0 && value % 1 === 0;
        }
      }
    },
    components: {
      MarkItem,
      DynamicArrow
    }
  };
</script>

<style lang="scss">
  @import '~styles/scss/media.scss';

  .counter-marker__container {
    display: flex;
    align-items: stretch;
    height: 250px;
  }
  .mark-group {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    cursor: pointer;
    @include respond-to(tabletRotate) {
      cursor: auto;
    }
  }

  @include respond-to(tabletRotate) {
    .counter-marker__container {
      align-items: stretch;
      height: auto;
      flex-direction: row;
      flex-wrap: wrap;
      & > * {
        flex-grow: 1;
        flex-basis: 100%;
      }
    }

    .mark-group {
      flex-direction: row;
      order: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CounterMarks/CounterMarks.vue